
export const Period = ({data}) => {  

 let openTimeMinuteString= data.openTimeMinute.toString();
 let closeTimeMinuteString= data.closeTimeMinute.toString();

  return (
    <div>
        <small>
          {data.openTimeHour}:{openTimeMinuteString.length > 1 ? data.openTimeMinute : "00" } - {data.closeTimeHour}:{closeTimeMinuteString.length > 1 ? data.closeTimeMinute : "00" } 
        </small>       
    </div>
  )
}
